import routeParams from './routeParams'


type Match = {
  isExact: boolean
  params: object
  path: string
  url: string
  isSEOPage?: boolean
  pageURL?: string
}

/**
 * @namespace
 * @property {string} page
 * @property {string} pageType
 * @property {string} flow - net, org, facebook
 */
let context = {}

const setFromRouteMatch = (match: Match): object => {
  const { path, isSEOPage, pageURL } = match

  if (isSEOPage) {
    context = {
      page: 'SEO',
      pageURL,
    }
  }
  else {
    context = routeParams[path] || {}
  }

  if (typeof window !== 'undefined') {
    if (!window.__debug__) {
      window.__debug__ = {}
    }

    window.__debug__.snowplowContext = context
  }

  return context
}

const set = (values: any) => context = values
const get = () => context


export default {
  setFromRouteMatch,
  set,
  get,
}
